/**
 * Turn Waiting Screen — "Pass phone to [Player]" + START button.
 */

import { getState, getCurrentCardReader, startTurn } from '../game-state';
import { RoundNumber } from '../../shared/types';
import { navigate } from '../router';
import { t, getRoundName } from '../i18n';

export function renderTurnWaiting(): void {
  const app = document.getElementById('app')!;
  const state = getState();
  const cardReader = getCurrentCardReader();
  const round = state.currentRound;

  app.innerHTML = `
    <div class="round-interstitial">
      <p class="text-muted" style="margin-bottom: var(--space-sm);">${t('round')} ${round}: ${getRoundName(round)}</p>
      <h1 style="font-size: var(--font-size-xl);">${t('passPhoneTo')}</h1>
      <div class="round-name" style="margin-top: var(--space-sm);">${cardReader?.displayName || t('nextPlayer')}</div>
      <p class="text-secondary" style="margin-bottom: var(--space-xl);">
        ${t('team', state.currentTeam)}
      </p>

      <button class="btn btn-primary" id="btn-start" style="font-size: var(--font-size-xl); padding: var(--space-lg);">
        ${t('start')}
      </button>
    </div>
  `;

  document.getElementById('btn-start')?.addEventListener('click', () => {
    startTurn();
    navigate('turn-active');
  });
}
